import { List, Icon } from "components";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "ui/components/dropdown-menu";
import { Button } from "ui/components/button";
import { MENU } from "icons";
import CreateListItemButton from "@/components/list/create-button";
import { StatusCell } from "@/components/status/cell";
import { useRemoveEntity } from "./crud/delete/mutation";
import { useNavigate } from "react-router-dom";
import { PermissionControlledInput } from "permissions/components/input";
import { eventBus } from "utils/eventBus";

export default function OrganizationEntities() {
  const navigate = useNavigate();
  const removeEntityMutation = useRemoveEntity({
    onSuccess: () => {
      eventBus.emit("refresh:list", "legal_entitiesorganization-entities");
    },
  });

  const handleDelete = (entityId) => {
    removeEntityMutation.mutate({ entityId });
  };

  const fields = ["id", "name", "status", "organisation.name"];

  const columns = [
    {
      header: "Name",
      accessorKey: "name",
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      header: "Organization",
      accessorKey: "organisation.name",
    },
    {
        id: "actions",
        header: "",
        accessorKey: "id",
        cell: ({ row }) => {
            const id = row.original.id;
            return (
                <div className="flex items-center gap-2 justify-end opacity-0 group-hover:opacity-100 transition">
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button size="icon" variant="outline">
                                <Icon icon={MENU} className="size-4" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent>
                            <PermissionControlledInput
                                rule="delete:*"
                                collection="legal_entities"
                                showWhenDisabled={true}
                            >
                                <DropdownMenuItem
                                    onClick={() => handleDelete(id)}
                                    className="cursor-pointer"
                                >
                                    Delete
                                </DropdownMenuItem>
                            </PermissionControlledInput>
                        </DropdownMenuContent>
                    </DropdownMenu>
                </div>
            );
        },
        sortable: false,
        meta: { align: "right" },
    },
  ];

  return (
    <div className="flex-1">
      <List
        attrs={fields}
        endPoint="legal_entities"
        meta={{ fields }}
        title={"Entities"}
        columns={columns}
        // hidePagination={true}
        href={(item) => item.id}
        storageKey={"organization-entities"}
      />
      <CreateListItemButton rule="create:*" collection="legal_entities">
        Entity
      </CreateListItemButton>
    </div>
  );
}
